module.exports = __webpack_public_path__ + "static/media/ink.908abf6e.svg";